import { FC } from 'react';

import { Button } from 'components/parts/Button';

import styles from '../Card.module.scss';

import {
  getClearCardFileName,
  formatCardName,
  formatUnlockCardName,
} from 'components/pages/Card/model/helpers';
import { CardItem } from 'components/pages/Card/model/types';
import { cardPageImages } from 'components/pages/Card/images';

type Props = {
  card: CardItem;
  handleOpenModal: (data: CardItem) => void;
  handleReceiveClick: (card: CardItem) => void;
};

export const ListCardItemView: FC<Props> = ({ card, handleOpenModal, handleReceiveClick }) => {
  return (
    <div key={card.id} className={styles.cardItem}>
      <>
        {card.status.completed ? (
          <div className={styles.clearCard}>
            <button onClick={() => handleOpenModal(card)} className={styles.clearCardButton}>
              <img
                src={require(`components/pages/Area/images/${getClearCardFileName(card)}`)}
                alt={`クリアカード：${formatCardName(card.name, false)}`}
                className={styles.clearCardImage}
              />
            </button>
          </div>
        ) : (
          <div className={styles.unlockCard}>
            <img
              src={card.type === 'area' ? cardPageImages.cardUnlock : cardPageImages.cardUnlockAlt}
              alt=""
              className={styles.unlockCardImage}
            />
            <span className={styles.unlockCardTextWrap}>
              <span
                dangerouslySetInnerHTML={{ __html: formatUnlockCardName(card.name) }}
                className={styles.unlockCardText}
              />
            </span>
          </div>
        )}
        {/* カード受け取り済み */}
        {card.type === 'area' && card.status.receivedClearCard && (
          <div className={styles.action}>
            <Button text="受取済み" styleType="secondaryMini" disabled={true} />
          </div>
        )}
        {/* クリア済みだが、カードは受け取っていない */}
        {card.type === 'area' && card.status.completed && !card.status.receivedClearCard && (
          <div className={styles.action}>
            <Button
              text="カード受取"
              styleType="secondaryMini"
              handleClick={() => handleReceiveClick(card)}
              addClass={[styles.receiveButton]}
              disabled={!card.status.completed}
            />
          </div>
        )}
        {/* クリアしていない（出力しない） */}
      </>
    </div>
  );
};
